import { FilterOption } from '../Filter/Filter';

export const PokersiteOptions: Array<FilterOption & { value: number | undefined }> = [
  { id: 0, label: 'All', value: undefined },
  { id: 1, label: 'PS', value: 1 },
  { id: 2, label: 'CHI', value: 2 },
  { id: 3, label: 'WPN', value: 3 },
  { id: 4, label: '888', value: 4 },
  { id: 5, label: 'CPR', value: 5 },
  { id: 6, label: 'IP', value: 6 },
];
